import { Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { ProtectedAdmin } from './components/ProtectedAdmin'
import { AdminShell } from './components/AdminShell'
import { Home } from './pages/Home'
import { Catalog } from './pages/Catalog'
import { Product } from './pages/Product'
import { Checkout } from './pages/Checkout'
import { OrderSuccess } from './pages/OrderSuccess'
import { StaticPage } from './pages/StaticPage'
import { AdminLogin } from './pages/admin/AdminLogin'
import { AdminDashboard } from './pages/admin/AdminDashboard'
import { AdminProducts } from './pages/admin/AdminProducts'
import { AdminProductEditor } from './pages/admin/AdminProductEditor'
import { AdminContent } from './pages/admin/AdminContent'
import { AdminOrders } from './pages/admin/AdminOrders'
import { AdminPayments } from './pages/admin/AdminPayments'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="produtos" element={<Catalog />} />
        <Route path="produto/:slug" element={<Product />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="pedido/:orderNumber" element={<OrderSuccess />} />
        <Route path="contato" element={<StaticPage title="CONTATO"><p>Configure o email e WhatsApp da loja no painel administrativo.</p></StaticPage>} />
        <Route path="trocas" element={<StaticPage title="TROCAS E DEVOLUÇÕES"><p>Adicione aqui a política oficial da GK Maison antes de publicar a loja.</p></StaticPage>} />
        <Route path="privacidade" element={<StaticPage title="PRIVACIDADE"><p>Adicione aqui a política de privacidade e tratamento de dados.</p></StaticPage>} />
        <Route path="termos" element={<StaticPage title="TERMOS"><p>Adicione aqui os termos de uso e compra da loja.</p></StaticPage>} />
        <Route path="*" element={<StaticPage title="404"><p>Página não encontrada.</p></StaticPage>} />
      </Route>

      <Route path="/admin/login" element={<AdminLogin />} />
      <Route element={<ProtectedAdmin />}>
        <Route path="/admin" element={<AdminShell />}>
          <Route index element={<AdminDashboard />} />
          <Route path="produtos" element={<AdminProducts />} />
          <Route path="produtos/novo" element={<AdminProductEditor />} />
          <Route path="produtos/:id" element={<AdminProductEditor />} />
          <Route path="conteudo" element={<AdminContent />} />
          <Route path="pedidos" element={<AdminOrders />} />
          <Route path="pagamentos" element={<AdminPayments />} />
        </Route>
      </Route>
    </Routes>
  )
}
